import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';

import { TXTWCL_Bet_Builder } from './BetBuilderIcon.messages.json';
import styles from './BetBuilderIcon.scss';

interface Props {
  isActive?: boolean;
}

const BetBuilderIcon: React.FC<Props> = ({ isActive }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <div className={styles.iconContainer}>
      {!isActive && <div className={styles.background} />}
      <Icon name="bet-builder" className={styles.icon} label={formatMessage(TXTWCL_Bet_Builder)} />
    </div>
  );
};

export default BetBuilderIcon;
